export default "__VITE_ASSET__BfiZE0mY__";